<template>
  <div>
    
    <modal 
      class="dialer_animation right_side_popup m-w-600 scrollable bigSquareCheckbox IosModal" 
      width="50%" 
      :scrollable="true" 
      height="auto"  
      :name="modalName" 
      @before-open="onBeforeOpen($event)" 
      @before-close="onBeforeClose()"
    >
      <div class="d-flex align-items-center mb-3 calc-title-widthIOS v2">
        <div class="settingsTextAndIconOnTop" @click="api.add_team.send?'':$modal.hide(modalName)">
          <vb-icon icon="backToSettingsList-IOSIcon" width="11.434" height="20" />
        </div>
        <div class="dialer-settings-title topMainHeading">Add Team</div>
        <div class="plus-IOSIcon-container" @click="$modal.show('CheckedSlot',{ service: 'team', onProceed: addTeam, })">
          <div class="textInsideCard onRightSide primaryColor">Detail</div>
        </div>
      </div>
      <div class="innerModalIos">

        <form class="dialer-form lg-mar-bottom" @submit.prevent="addTeam()">
          <b-alert class="mt-32px" :show="!!api.add_team.error_message" variant="danger">{{api.add_team.error_message}}</b-alert>
          <div class="basicWhiteIOScard mt-32px mb-16px">
            <div class="basicWhiteIOScard-item">
              <div class="mobileInputIOS InputIosV2">
                <label>Name</label>
                <input 
                  placeholder="Main Office, Sales etc..." 
                  class="w-100" 
                  type="text" 
                  onkeypress="return /([0-9A-Za-z \s])/i.test(event.key)" 
                  :disabled="api.add_team.send" 
                  v-model="forms.team.name" 
                />
                <p 
                  v-if="(forms.team.submitted && $v.forms.team.name.$invalid) || api.add_team.validation_errors.name" 
                  class="text text-danger animated bounceIntop"
                >
                  <span v-if="!$v.forms.team.name.required">* Name is required</span>
                  <span v-for="em in api.add_team.validation_errors.name" :key="em">* {{ em }}</span>
                </p>
              </div>
            </div>
          </div>
          <button class="IosFullWidthButton forDone mb-16px" :disabled="api.add_team.send">
            <vb-spinner v-if="api.add_team.send" />
            <template v-else>Add</template>
          </button>
        </form>

      </div>
    </modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
import { VOIP_API } from '@/utils/index';
export default {
  name: "AddTeamModal",
  props: {
    modalName: {
      type: String,
      default: 'AddTeam',
    },
  },
  data() {
    return {
      forms: {
        team: this.$helperFunction.formInstance({
          data: {
            name: '',
            description: '',
          }
        }),
      },
      api: {
        add_team: this.$helperFunction.apiInstance({ validation_errors: true, error_message: true }),
      },
    };
  },
  computed: {
    ...mapGetters(['getCurrentUser','getIsMobile']),
  },
  validations: {
    forms: {
      team: {
        name: { 
          required 
        },
      },
    },
  },
  methods: {
    onBeforeOpen(event){
      this.forms.team.name=event?.params?.suggested_name ?? ''
    },
    onBeforeClose(){
      this.forms.team.reset()
      this.api.add_team.reset()
    },
    addTeam() {
      let vm = this
      vm.forms.team.submitted = true;
      vm.$v.forms.team.$touch();
      if (vm.$v.forms.team.$invalid || vm.api.add_team.send) return;
      vm.api.add_team.send = true;
      vm.api.add_team.validation_errors = {};
      vm.api.add_team.error_message = '';
      VOIP_API.endpoints.teams.create({
        name: vm.forms.team.name,
        description: vm.forms.team.description,
        service: 'team',
        default_account: vm.getCurrentUser.default_accountcode,
        accountcode: vm.getCurrentUser.account,
        uid: vm.getCurrentUser.uid,
      }).then(() => {
        vm.$modal.hide(vm.modalName)
        vm.$emit('interface');
      }).catch(ex => {
        vm.api.add_team.validation_errors = ex.own_errors;
        vm.api.add_team.error_message = ex.own_message;
      }).finally(()=>{
        vm.forms.team.submitted = false;
        vm.api.add_team.send = false;
      });
    },
  },
};
</script>
